import React, { useState, useEffect } from "react";
import {
  query,
  collection,
  limit,
  orderBy,
  where,
  getDocs,
  documentId,
} from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { useLeague } from "context/leagueContext";

import Leaderboard from "components/leaderboard";

const LeagueLeaderboard = ({ hideElimintated, resultLimit }) => {
  const [userList, setUserList] = useState([]);
  const [winnerList, setWinnerList] = useState([]);

  const {
    state: { leagueInfo },
  } = useLeague();

  const firestore = useFirestore();

  const leaderboardCollection = collection(
    firestore,
    "userTournaments/" + leagueInfo?.id + "/users/"
  );
  let leaderboardQuery = query(leaderboardCollection);

  if (hideElimintated) {
    leaderboardQuery = query(leaderboardQuery, where("gameOver", "==", false));
  }

  if (leagueInfo?.gameRule == 3) {
    leaderboardQuery = query(leaderboardQuery, orderBy("leaguePicks", "desc"));
  } else {
    leaderboardQuery = query(leaderboardQuery, orderBy("points", "desc"));
  }
  leaderboardQuery = query(
    leaderboardQuery,
    limit(resultLimit ? resultLimit : 25)
  );

  const { status: leaderboardStatus, data: leaderboardUsers } =
    useFirestoreCollectionData(leaderboardQuery, {
      idField: "id",
    });

  useEffect(() => {
    if (leaderboardUsers) {
      if (
        leaderboardUsers.length == 0 &&
        leagueInfo?.winners &&
        leagueInfo?.settled
      ) {
        getWinners(leagueInfo?.winners);
      } else {
        setUserList(leaderboardUsers);
      }
    }
  }, [leaderboardUsers]);

  async function getWinners(users) {
    let winnerQuery = query(
      collection(firestore, "userTournaments/" + leagueInfo?.id + "/users/"),
      where(documentId(), "in", users)
    );
    const winnerSnapshot = await getDocs(winnerQuery);

    const winnerDocs = winnerSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    if (winnerSnapshot.docs.length != 0) setWinnerList(winnerDocs);
  }

  return (
    <div className="rounded-md bg-white mx-2 pb-2">
      {!userList.length && leagueInfo?.settled ? (
        <Leaderboard
          users={winnerList}
          isLoading={leaderboardStatus === "loading"}
          settled={leagueInfo?.settled}
          hideElimintated={hideElimintated}
          isRound={false}
        />
      ) : (
        <Leaderboard
          users={userList}
          isLoading={leaderboardStatus === "loading"}
          settled={leagueInfo?.settled}
          hideElimintated={hideElimintated}
          isRound={false}
        />
      )}
    </div>
  );
};

export default LeagueLeaderboard;
